export var testThemeSeed = {
    // global font color
    // header links divider
    color1: "red",
    // details content border
    // list item border (inactive)
    // company logo border
    color2: "#E3E6E8",
    // apply button text
    // search button text
    // pagination button text (when active)
    color3: "#FFFFFF",
    // apply button background
    // input border (when focused)
    // search button background
    // company name in listing
    color4: "#1B75D0",
    // apply button background (when hover)
    // search button background (when hover)
    color5: "#155CA2",
    // pagination button border
    // footer link text
    // footer content
    // input border
    color6: "#BABFC5",
    // input text (when focus)
    // details title
    // footer background
    color7: "#0C0D0E",
    // list item border (when active)
    // pagination button border (when active)
    // pagination button background (when active)
    color8: "#E7700D",
    // list item background (when hover)
    // salary badges background
    color9: "#F1F2F3",
    // salary badge text
    // list item title
    // company name in details
    // top banner text
    // top banner link
    color10: "#3B4045",
    // pagination button background (when hover)
    color11: "#D6D9DC",
    // top banner background
    color12: "#F4F4FE",
    // top banner border
    color13: "#BABDEE",
};
